module.exports = __webpack_public_path__ + "media/images/guide/anotacion/image4-9590d6c3b335d0189101490a44f186f8.png";